import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	modalHeader: {
		id: 'project-soft-delete-modal.modal-header',
		defaultMessage: 'Move to trash?',
		description: 'The modal header for Move to trash action',
	},
	explainWhatDeleteDoesPart1: {
		id: 'project-soft-delete-modal.explain-what-delete-does-part-1',
		defaultMessage:
			'The project along with its issues, Jira components, attachments, and versions will be available in the trash for 60 days after which it will be permanently deleted.',
		description: 'Explanation for Move to trash action',
	},
	explainWhatDeleteDoesPart2: {
		id: 'project-soft-delete-modal.explain-what-delete-does-part-2',
		defaultMessage: 'Only Jira admins can restore the project from the trash.',
		description: 'Explanation for Move to trash action',
	},
	confirmDeleteButton: {
		id: 'project-soft-delete-modal.confirm-delete-button',
		defaultMessage: 'Move',
		description: 'Confirmation of Move to trash action',
	},
	explainWhatDeleteDoesPart1ServiceDesk: {
		id: 'project-soft-delete-modal.explain-what-delete-does-part-1-service-desk',
		defaultMessage:
			'This service project along with its requests, queues, automation rules, SLAs, and reports will be moved to trash.',
		description: 'Explanation for Move to trash action',
	},
	explainWhatDeleteDoesPart2ServiceDesk: {
		id: 'project-soft-delete-modal.explain-what-delete-does-part-2-service-desk',
		defaultMessage:
			'Only Jira admins can restore the service project from trash within 60 days. After 60 days, it will be permanently deleted.',
		description: 'Explanation for Move to trash action',
	},
	confirmDeleteButtonServiceDesk: {
		id: 'project-soft-delete-modal.confirm-delete-button-service-desk',
		defaultMessage: 'Move to trash',
		description: 'Confirmation of Move to trash action',
	},
	cancelDeleteButton: {
		id: 'project-soft-delete-modal.cancel-delete-button',
		defaultMessage: 'Cancel',
		description: 'Cancellation of Move to trash action',
	},
	deleteSuccessMessageTitle: {
		id: 'project-soft-delete-modal.delete-success-message-title',
		defaultMessage: 'Project successfully moved to trash',
		description: 'Title for success message when project is trashed',
	},
	deleteSuccessServiceDeskMessageTitle: {
		id: 'project-soft-delete-modal.delete-success-service-desk-message-title',
		defaultMessage: 'Service project successfully moved to trash',
		description: 'Title for success message when a service desk project is trashed',
	},
	deleteSuccessGoToTrashButtonTitle: {
		id: 'project-soft-delete-modal.delete-success-go-to-trash-button-title',
		defaultMessage: 'Go to trash',
		description:
			'Title for the go-to-trash button on the success message after trashing a project.',
	},
	deleteSuccessRestoreButtonTitle: {
		id: 'project-soft-delete-modal.delete-success-restore-button-title',
		defaultMessage: 'Restore',
		description: 'Title for the restore button on the success message after trashing a project.',
	},
	deleteErrorMessageTitle: {
		id: 'project-soft-delete-modal.delete-error-message-title',
		defaultMessage: 'Something went wrong',
		description: 'Title for error message when project trash failed',
	},
	deleteErrorMessageDescription: {
		id: 'project-soft-delete-modal.delete-error-message-description',
		defaultMessage: 'We couldn’t move the "{projectName}" project to trash. Try again.',
		description: 'Description for error message when project trash failed',
	},
	deleteCustomerServiceErrorMessageTitleNonFinal: {
		id: 'project-soft-delete-modal.delete-customer-service-error-message-title-non-final',
		defaultMessage: 'This project cannot be deleted',
		description: 'Title for error message when project trash failed',
	},
	deleteCustomerServiceErrorMessageDescriptionNonFinal: {
		id: 'project-soft-delete-modal.delete-customer-service-error-message-description-non-final',
		defaultMessage:
			'We couldn’t move the "{projectName}" project to trash as it is referenced by a Help Center.',
		description: 'Description for error message when project trash failed',
	},
	learnMoreAboutTrashAndRestore: {
		id: 'project-soft-delete-modal.learn-more-about-trash-and-restore',
		defaultMessage: 'Learn more about trash and restore.',
		description: 'Description for learn more about trash and restore.',
	},
});
